module.exports = __webpack_public_path__ + "static/img/2.bad75393.png";